/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.zem.ZemAnswerType
*/
export var ZemAnswerType;
(function (ZemAnswerType) {
    ZemAnswerType["NOUL"] = "NOUL";
    ZemAnswerType["CHOICE"] = "CHOICE";
    ZemAnswerType["SCORE"] = "SCORE";
    ZemAnswerType["REFUSAL"] = "REFUSAL";
})(ZemAnswerType || (ZemAnswerType = {}));
//# sourceMappingURL=ZemAnswerType.js.map